import { Component } from "@angular/core"; import { Location } from "@angular/common";

@Component({
  selector: 'app-notfound',
  templateUrl: './app.notfound.component.html',
})
export class AppNotfoundComponent {

}
